module.exports = __webpack_public_path__ + "img/antes_despues_325.6ef6f7c7.png";